import React from "react";

const PendingButton = () => {
  return (
    <>
      <button
        className="btn btn-light ms-1"
        style={{
          fontSize: "8px",
          backgroundColor: " rgb(255, 248, 201)",
          color: " rgb(150, 112, 97)",
          paddingTop: "3px",
          paddingBottom: "2px",
          marginTop: "0px",
          marginBottom: "0px",
          paddingRight: "2px",
          paddingLeft: "0px",
          width: "54px",
          borderRadius: 0,
          fontFamily: "emoji",
          fontWeight: "700",
          //   border: "1px solid",
        }}
      >
        <i class="bi bi-clock"></i> {""}
        <span className="">Pending</span>
      </button>
    </>
  );
};

export default PendingButton;
